import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import companyInfo from '../data/companyInfo.json';
import servicesData from '../data/servicesData.json';
import '../styles/Home.css';

import banner1 from '../assets/images/banner1.jpg';
import banner2 from '../assets/images/banner2.jpg';
import banner3 from '../assets/images/banner3.jpg';
import banner4 from '../assets/images/banner4.jpg';

import about1 from '../assets/images/about1.jpg';
import about2 from '../assets/images/about2.jpg';
const Home = ({ onNavigate }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const banners = [
    { image: banner1, title: "Max Infra thrives on its People and Technical Capabilities" },
    { image: banner2, title: "Built Over Last Three Decades of History" },
    { image: banner3, title: "Building National Assets" },
    { image: banner4, title: "Creating tomorrow's infrastructure today" }
  ];

  // Auto-slide every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % banners.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [banners.length]);

  return (
    <div className="home">
      <Header onNavigate={onNavigate} />

      {/* HERO SECTION - AUTO SLIDER */}
      <section className="hero-slider">
        <div className="slider-container">
          <img 
            src={banners[currentSlide].image} 
            alt={banners[currentSlide].title}
            className="slider-image"
          />
          <div className="slider-overlay">
            <h1>{banners[currentSlide].title}</h1>
          </div>
        </div>
      </section>

   {/* ABOUT SECTION - IMAGE + CONTENT */}
<section className="about-section">
  <div className="container about-container">
    
   <div className="about-image">
  <img src={about1} alt="MaxInfra Company" className="section-image" />
</div>
    
    {/* RIGHT - CONTENT */}
    <div className="about-content">
      <h2>About MaxInfra</h2>
      <h3>Thriving on Core Competence</h3>
      <p>{companyInfo.description}</p>
      
      <button 
        className="btn-primary"
        onClick={() => onNavigate('about-us')}
      >
        Learn More
      </button>
    </div>
  </div>
</section>

{/* SECOND ABOUT SECTION - IMAGE + CONTENT (REVERSED) */}
<section className="about-section alternate-section">
  <div className="container about-container reversed">
    
    {/* LEFT - CONTENT */}
    <div className="about-content">
      <h2>Our Expertise</h2>
      <h3>Building National Assets</h3>
      <p>Max Infra specializes in executing large and complex projects across multiple sectors including Railways, Irrigation, Highways, Water Supply, Bridges, and Hydro Projects. With cutting-edge technology and a dedicated team of 5000+ employees, we deliver world-class infrastructure solutions.</p>
      
      <button 
        className="btn-primary"
        onClick={() => onNavigate('about-us')}
      >
        Explore Services
      </button>
    </div>

    {/* RIGHT - IMAGE */}
    <div className="about-image">
  <img src={about2} alt="MaxInfra Services" className="section-image" />
</div>
  </div>
</section>

      {/* SERVICES SECTION */}
      <section className="services-section">
        <div className="container">
          <h2>Business Verticals</h2>
          <p>Our Areas of Expertise</p>
          
          <div className="services-grid">
            {servicesData.map((service, index) => (
              <div 
                key={index} 
                className="service-card"
                onClick={() => onNavigate(service.id)}
                style={{ cursor: 'pointer' }}
              >
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;